// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.upload-container .el-upload {\n  width: auto;\n}\n.el-upload-list {\n  max-height: 350px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
